import AssetTree from '@rio-cloud/rio-uikit/AssetTree';
import type { IconType } from '@rio-cloud/rio-uikit/Icon';
import TreeCategory from '@rio-cloud/rio-uikit/TreeCategory';
import { useLocation, useNavigate } from 'react-router';

import styles from './SidebarMenu.module.scss';

export type SidebarMenuItem = {
    to: string;
    iconName: IconType;
    label: string;
};

export type SidebarMenuProps = {
    items: SidebarMenuItem[];
};

const SidebarMenu = ({ items }: SidebarMenuProps) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const currentItem = items.find(item => pathname.startsWith(item.to));

    const handleCategoryChange = (categoryId: string) => navigate(categoryId);

    return (
        <AssetTree
            className={styles.assetTree}
            currentCategoryId={currentItem?.to}
            onCategoryChange={handleCategoryChange}
            isOpen={false}
            onToggleTree={() => {}}
        >
            {items.map(item => (
                <TreeCategory key={item.to} id={item.to} iconName={item.iconName} label={item.label} />
            ))}
        </AssetTree>
    );
};

export default SidebarMenu;
